<template lang="pug">
  form
    .search-form(
      :class="{ 'search-form_big': big }"
    )
      .search-form__elem.search-form__elem_long(
        v-if="$route.name === 'Shifts'"
      )
        .search-form-elem.date-range-picker
          .search-form-elem__body
            date-range-picker(
              ref="rangeDatePicker"
              :locale-data="locale"
              :opens="opens"
              @update="updateDate"
              class="date-range-picker__input"
              :startDate="startDateRange"
              :endDate="endDateRange"
            )
            .date-range-picker__value(
              @click="onClickDatePicker()"
              :class="{ 'default-date': searchValues.date === 'Выберите даты' }"
            ) {{ startDate ? `${startDate}-${endDate}` : searchValues.date }}
            .date-range-picker__reset(
              v-if="startDate && endDate"
              @click="onResetDates()"
            )
      .search-form__elem.search-form__elem_long(
      v-if="$route.name !== 'Shifts'"
      )
        .search-form-elem
          .search-form-elem__title(
          v-show="!withoutTitle"
          ) {{ translation.title_screen.search_form.name.title }}
          .search-form-elem__body
            input.input.input_full(
            v-model="searchValues.name"
            )
      .search-form__elem.search-form__elem_long
        .search-form-elem
          .search-form-elem__title(
            v-show="!withoutTitle"
          ) {{ translation.title_screen.search_form.area.title }}
          .search-form-elem__body
            multiselect.custom-multiselect(
            v-model="searchValues.areas"
            placeholder="Введите район"
            :options="areaListData"
            :multiple="true"
            :showLabels="false"
            :closeOnSelect="false"
            :allowEmpty="false"
            @select="onSelectArea"
            @input="onInputArea"
            )
              template(
              slot="noResult"
              ) Ничего не найдено
              template(
              slot="selection"
              slot-scope="{ values, search, isOpen }"
              )
                span.multiselect__single(v-if="values.length && !isOpen")
                  | {{ setAreaMultiselectVal(values) }}
      <!--.search-form__elem.search-form__elem_long(-->
        <!--v-if="$route.name === 'Shifts'"-->
      <!--)-->
        <!--.search-form-elem-->
          <!--.search-form-elem__title(-->
          <!--v-show="!withoutTitle"-->
          <!--) Тип смены-->
          <!--.search-form-elem__body-->
            <!--simple-select-form(-->
            <!--:list-data="shiftCampTypeListData"-->
            <!--:default-value="searchValues.shiftCampType"-->
            <!--@onChangeDefaultValue="changeDefaultValue"-->
            <!--type="shiftCampType"-->
            <!--)-->
      .search-form__elem.search-form__elem_long(
        v-if="$route.name !== 'Shifts'"
      )
        .search-form-elem
          .search-form-elem__title(
            v-show="!withoutTitle"
          ) {{ translation.title_screen.search_form.camp_type.title }}
          .search-form-elem__body
            simple-select-form(
              :list-data="campTypeListData"
              :default-value="searchValues.campType"
              @onChangeDefaultValue="changeDefaultValue"
              type="campType"
            )
      <!--.search-form__elem.search-form__elem_short(-->
        <!--v-if="$route.name !== 'Shifts'"-->
      <!--)-->
        <!--.search-form-elem-->
          <!--.search-form-elem__title(-->
            <!--v-show="!withoutTitle"-->
          <!--) {{ translation.title_screen.search_form.season.title }}-->
          <!--.search-form-elem__body-->
            <!--simple-select-form(-->
              <!--:list-data="seasonListData"-->
              <!--:default-value="searchValues.season"-->
              <!--@onChangeDefaultValue="changeDefaultValue"-->
              <!--type="season"-->
            <!--)-->
      .search-form__elem.search-form__elem_short
        .search-form-elem
          .search-form-elem__title(
            v-show="!withoutTitle"
          ) {{ translation.title_screen.search_form.age.title }}
          .search-form-elem__body
            range-select-form(
              :default-value="searchValues.age"
              @onChangeDefaultValue="changeDefaultValue"
              type="age"
            )
      .search-form__elem
        .search-form-elem
          .search-form-elem__body
            button.button.button_paint-main.button_full(
              @click="onSearchCamps($event)"
            )
              .button__text {{ translation.title_screen.strart_search }}
</template>

<script>
import {mapActions, mapState} from "vuex";
import SimpleSelectForm from "@/components/simpleSelectForm/SimpleSelectForm.vue";
import RangeSelectForm from "@/components/rangeSelectForm/RangeSelectForm.vue";

import DateRangePicker from "vue2-daterange-picker";
import Multiselect from "vue-multiselect";

export default {
  name: "SearchForm",
  components: {
    SimpleSelectForm,
    RangeSelectForm,
    DateRangePicker,
    Multiselect
  },
  props: {
    big: {
      type: Boolean,
      default: false
    },
    withoutTitle: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      opens: "center",
      startDateRange: new Date(),
      endDateRange: new Date().valueOf() + 60 * 60 * 24 * 1000 * 7,
      startDate: null,
      endDate: null,
      locale: {
        direction: "ltr", //direction of text
        format: "MM/DD/YYYY", //fomart of the dates displayed
        separator: " - ", //separator between the two ranges
        applyLabel: "Применить",
        cancelLabel: "Отмена",
        weekLabel: "W",
        customRangeLabel: "",
        daysOfWeek: ["Вс", "Пн", "Вт", "Ср", "Ч", "Пт", "Сб"], //array of days - see moment documenations for details
        monthNames: [
          "Январь",
          "Февраль",
          "Март",
          "Апрель",
          "Май",
          "Июнь",
          "Июль",
          "Август",
          "Сетябрь",
          "Октябрь",
          "Ноябрь",
          "Декабрь"
        ], //array of month names - see moment documenations for details
        firstDay: 1 //ISO first day of week - see moment documenations for details
      },
      areaListData: [],
      campTypeListData: [],
      shiftCampTypeListData: [],
      seasonListData: [],
      defaultAreaIsSelected: true,
      searchValues: {
        name: "",
        areas: ["Все районы"],
        campType: {
          text: "Все лагеря",
          value: null
        },
        shiftCampType: {
          text: "Все профили",
          value: null
        },
        season: {
          text: "Все сезоны",
          value: null
        },
        age: "Любой возраст",
        date: "Выберите даты"
      }
    };
  },
  computed: {
    ...mapState(["catalogue", "translation", "lang"])
  },
  methods: {
    ...mapActions(["getSource"]),
    onResetDates() {
      this.startDate = null;
      this.endDate = null;
      this.startDateRange = new Date();
      this.endDateRange = new Date().valueOf() + 60 * 60 * 24 * 1000 * 7;
    },
    updateDate(date) {
      this.startDate = date.startDate.toLocaleDateString("en");
      this.endDate = date.endDate.toLocaleDateString("en");
    },
    getDateServerLocale(date) {
      const d = new Date(date);
      return `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(-2)}-${(
        "0" + d.getDate()
      ).slice(-2)}`;
    },
    onSearchCamps(e) {
      e.preventDefault();
      const _query = {};
      if (this.searchValues.name.length > 0) {
        _query.name = this.searchValues.name;
      }
      if (this.searchValues.areas.join(",") !== "Все районы") {
        _query.areas = this.searchValues.areas.join(",");
      }
      if (this.searchValues.campType.value !== null) {
        _query.type = this.searchValues.campType.value;
      }
      if (this.searchValues.shiftCampType.value !== null) {
        _query.type = this.searchValues.shiftCampType.value;
      }
      if (this.searchValues.season.value !== null) {
        _query.season = this.searchValues.season.value;
      }
      if (this.searchValues.age !== "Любой возраст") {
        const ages = this.searchValues.age.split(" - ");
        _query.age_from = parseInt(ages[0]);
        _query.age_to = parseInt(ages[1]);
      }
      if (this.startDate && this.endDate) {
        _query.date_started = this.getDateServerLocale(this.startDate);
        _query.date_finished = this.getDateServerLocale(this.endDate);
      }
      const routeNames = {
        Camps: "Camps",
        Shifts: "Shifts",
        MainPage: "Camps"
      };
      this.$router.push({name: routeNames[this.$route.name], query: _query});
    },
    changeDefaultValue(value, type) {
      this.searchValues[type] = value;
    },
    onInputArea(val) {
      if (this.defaultAreaIsSelected) {
        this.searchValues.areas = val.filter(item => {
          return item === this.areaListData[0];
        });
      } else {
        this.searchValues.areas = val.filter(item => {
          return item !== this.areaListData[0];
        });
      }
    },
    onSelectArea(val) {
      if (val === this.areaListData[0]) {
        this.defaultAreaIsSelected = true;
      } else {
        this.defaultAreaIsSelected = false;
      }
    },
    onCreateDefaultValues() {
      document.body.className = `lang-${this.lang}`;
      this.searchValues = {
        name: "",
        areas: [this.translation.title_screen.search_form.area.default_value],
        // area: null,
        campType: {
          text: this.translation.title_screen.search_form.camp_type
            .default_value,
          value: null
        },
        shiftCampType: {
          text: "Все профили",
          value: null
        },
        season: {
          text: this.translation.title_screen.search_form.season.default_value,
          value: null
        },
        age: this.translation.title_screen.search_form.age.default_value,
        date: "Выберите даты"
      };
    },
    setAreaMultiselectVal(val) {
      if (val.length > 1) {
        return "Выбрано " + val.length;
      }
      return val[0];
    }
  },
  mounted() {
    this.onCreateDefaultValues();
    this.campTypeListData = this.catalogue.campTypes;
    this.shiftCampTypeListData = this.catalogue.shiftCampTypes;
    this.seasonListData = this.catalogue.campSeasons;
    this.areaListData = this.catalogue.areas;
    const {
      name,
      areas,
      type,
      season,
      age_from,
      age_to,
      date_started,
      date_finished
    } = this.$route.query;
    if (name !== undefined) {
      this.searchValues.name = name;
    }
    if (areas !== undefined) {
      const areasArr = areas.split(",");
      const newAreasArr = [];
      areasArr.forEach(area => {
        const _areas = this.areaListData.find(el => el === area);
        if (_areas) {
          newAreasArr.push(area);
        }
      });
      if (newAreasArr.length > 0) {
        this.searchValues.areas = newAreasArr;
      }
    }
    if (type !== undefined && this.$route.name === "Camps") {
      const _type = this.campTypeListData.find(el => el.value === +type);
      if (_type) {
        this.searchValues.campType = _type;
      }
    }
    if (type !== undefined && this.$route.name === "Shifts") {
      const _type = this.shiftCampTypeListData.find(el => el.value === +type);
      if (_type) {
        this.searchValues.shiftCampType = _type;
      }
    }
    if (season !== undefined) {
      const _season = this.seasonListData.find(el => el.value === +season);
      if (_season) {
        this.searchValues.season = _season;
      }
    }
    if (age_from !== undefined && age_to !== undefined) {
      this.searchValues.age = `${age_from} - ${age_to} лет`;
    }
    if (date_started !== undefined && date_finished !== undefined) {
      this.startDate = new Date(date_started).toLocaleDateString();
      this.endDate = new Date(date_finished).toLocaleDateString();
      this.startDateRange = date_started;
      this.endDateRange = date_finished;
    }
  },
  watch: {
    lang() {
      this.onCreateDefaultValues();
    }
  }
};
</script>
